import { SERVER_CONFIG } from '@helpers/constants';
import httpClient from './index.service';

export async function fetchQuoteProductList(params?: any) {
  const paramList: any = [];
  if (params) {
    Object.entries(params).forEach((param: any) => {
      const [key, value] = param;
      if (value) {
        paramList.push(`${key}=${value}`);
      }
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.formFilterOptions.index}/${
        SERVER_CONFIG.product
      }?${paramList?.length ? paramList.join('&') : ``}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

/**
 * CPD (central Product Database) product list, proxied by the backend.
 * Paginated: { count, next, previous, results: [{ cpd_product_id, product_name, product_id, hs_code, primary_cas_number }] }
 */
export async function fetchCpdProductList(params: {
  search?: string | null;
  page?: number;
  page_size?: number;
}) {
  const query = new URLSearchParams();
  if (params?.search) query.append('search', params.search);
  query.append('page', String(params?.page ?? 1));
  query.append('page_size', String(params?.page_size ?? 20));
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.formFilterOptions.index}/${
        SERVER_CONFIG.cpdProduct
      }?${query.toString()}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function fetchQuoteCustomerList(params?: any) {
  const paramList: any = [];
  if (params) {
    Object.entries(params).forEach((param: any) => {
      const [key, value] = param;
      if (value) {
        paramList.push(`${key}=${value}`);
      }
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.formFilterOptions.index}/${
        SERVER_CONFIG.updateCustomer
      }?${paramList?.length ? paramList.join('&') : ``}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
}

export const submitNonConsolidationQuote = async (data: any) => {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}`,
      data
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const submitConsolidationQuote = async (data: any) => {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${SERVER_CONFIG.consolidation}`,
      data
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const getEnquiryDetails = async (enquiryId: string) => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${enquiryId}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const addQuote = async (enquiryId = '', data: any) => {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${SERVER_CONFIG.quote}${enquiryId}/`,
      data
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const updateQuote = async (enquiryId = '', data: any) => {
  try {
    const response = await httpClient.put(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${SERVER_CONFIG.quote}${enquiryId}/`,
      data
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const updateNonConsolidationEnquiry = async (enquiryId: string, data: any) => {
  try {
    const response = await httpClient.put(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${enquiryId}/`,
      data
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const fetchCustomerEnquiryPrefill = async (customerEnquiryId: string) => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.v2Enquiry}${customerEnquiryId}/${SERVER_CONFIG.prefill}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const getEnquiryList = async (params: any) => {
  const paramList: any = [];
  if (params) {
    Object.entries(params).forEach((param: any) => {
      const [key, value] = param;
      if (value) {
        paramList.push(`${key}=${value}`);
      }
    });
  }
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}?${
        paramList?.length ? paramList.join('&') : ``
      }`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const getGeneratePDFOptions = async () => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.formFilterOptions.index}/${SERVER_CONFIG.formFilterOptions.pdfOptions}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const submitGeneratePDF = async (enquiryId: string, reqBody: any) => {
  try {
    const response = await httpClient.post(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.pdf}${enquiryId}/`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const getQuoteDocuments = async (enquiryId: string) => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.pdf}${enquiryId}/`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const editEnquiryAndProduct = async (enquiryId: string, reqBody: any) => {
  try {
    const response = await httpClient.put(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${enquiryId}/`,
      reqBody
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const fetchQuoteTableAdhocOptions = async (params: any) => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.formFilterOptions.index}/${SERVER_CONFIG.formFilterOptions.pdfOptions}?${params}`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};

export const fetchQuoteActivity = async (enquiryId: string) => {
  try {
    const response = await httpClient.get(
      `${SERVER_CONFIG.quoteGeneration}${SERVER_CONFIG.enquiry}/${SERVER_CONFIG.activity}${enquiryId}/`
    );
    return response;
  } catch (error: any) {
    return error;
  }
};
